/**
 * It's a generated file, preferable to extend this in external file
 */
import * as yup from 'common/yup';
import {DiplomatObject} from './DiplomatObject';
import {AbstractServer} from 'types/transport/Abstract/AbstractServer';
import {enumType} from 'common/enumType';

export const IncomingEmailType = enumType({
   IMAP: 'IMAP',
   POP3: 'POP3',
});

export const EmailServerSettings = DiplomatObject.shape({
   outgoingServer: AbstractServer,
   incomingServer: AbstractServer,
   transSubjectTemplate: yup.string(),
});

export type IEmailServerSettings = yup.InferType<typeof EmailServerSettings>;
